module.exports = __webpack_public_path__ + "static/media/hospital.05d09ace.svg";